import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import BaseScreenTable from '../../../../../../../baseComponents/TwinTable/BaseScreenTable'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import ModalCreateSellOrder from './ModalCreateSellOrder'
import TableSellOrders from '../../../../../../../specificComponents/sells/TableSellOrders'

interface SellOrdersProps extends ComponentWithPermissions { }

const SellOrders: React.FC<SellOrdersProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('orders', 'Pedidos'),
        newText: t('newOrder', 'Nuevo pedido'),
    }
    return (
        <BaseScreenTable TableComponent={TableSellOrders} CreateModalComponent={ModalCreateSellOrder} pageData={pageData} userPermissions={userPermissions} />
    )
}

export default SellOrders